<template>
  <b-card title="ویس">
    <b-card-text>
      <span>در این قسمت می توانید به محتوای خود ویس اضافه کنید </span>
    </b-card-text>


    <b-row>
      <b-col cols="12">
        <b-form-group
            label="نام محتوا "
        >
          <b-form-input
              placeholder="این نام داخل اپلیکیشن نمایش داده نمی شود "
              v-model="data.name"
          />
        </b-form-group>
        <b-form-group
            label="آپلود ویس"

        >
          <b-form-file
              v-model="file"
              placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
              drop-placeholder="Drop file here..."
              @change="fileSelected"
              accept=".mp3"

          />

        </b-form-group>
      </b-col>

      <b-col cols="6">
        <av-bars
            :audio-src="this.voiceUrl">
        </av-bars>
      </b-col>
    </b-row>





    <b-form-group>
      <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="success"
          class="mr-1 mt-1"
          @click="SaveContent"
      >
        ثبت
      </b-button>
    </b-form-group>

  </b-card>
</template>

<script>
import {BFormTextarea, BCardText,BRow,BCol, BFormFile,BCard, BFormGroup, BFormInput, BButton} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import UploadFile from '@/modules/components/upload/uploadFile'
import uploadService from "@/modules/services/uploadService";
import {$appConfig} from "../../../../appConfig";

export default {
  name: "voiceFormComponent",
  components: {
    BCard,
    BButton,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BCardText,
    UploadFile,
    BFormFile,
    BRow,
    BCol

  },
  data() {
    return {
      file:undefined,
      voiceUrl :'',
      data: {
        name: '',
        voiceAddress: '',
        link:''
      },
    }
  },
  methods: {
    async SaveContent(event) {
      this.data.voiceAddress =$appConfig.endpoint.baseFileDomain + '/' + await uploadService.upload(this.file)
      this.$emit('voiceFormSubmit', this.data)
    },
    fileSelected(evt){

      let selectedFile = evt.target.files[0]
      this.voiceUrl = URL.createObjectURL(selectedFile);
      console.log(this.voiceUrl);

    }
  }
  ,
  directives: {
    Ripple,
  },

}
</script>

<style scoped>
.ck-editor__editable  {
  height: 400px !important;
}
</style>
